// 生产菜单接口
import axios from 'axios'

// 衣物列表(分页)
export function getOrderItem(data) {
  return axios({
    url: `/api/oms/orderItem/listPage`,
    method: 'get',
    params: data
  })
}
// 衣物删除
export function deleteOrderItem(id) {
  return axios({
    url: `/api/oms/orderItem/delete?id=${id}`,
    method: 'get'
  })
}
// 衣物修改
export function updateOrderItem(data) {
  return axios({
    url: `/api/oms/orderItem/update`,
    method: 'post',
    data
  })
}
// 新增衣物
export function insertOrderItem(data) {
  return axios({
    url: `/api/oms/orderItem/insert`,
    method: 'post',
    data
  })
}
// 衣物列举图片
// ossFolderName
export function listFile(ossFolderName) {
  return axios({
    url: `/api/oms/orderItem/listFile?ossFolderName=${ossFolderName}`,
    method: 'get'
  })
}
// get衣物上传图片
// file,ossFolderName
export function uploadFile(data) {
  return axios({
    url: `/api/oms/orderItem/uploadFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post衣物上传图片
export function uploadFiles(data) {
  return axios({
    url: `/api/oms/orderItem/uploadFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post衣物图片删除 filePath,ossFolderName
export function deleteFiles(data) {
  return axios({
    url: `/api/oms/orderItem/deleteFile`,
    method: 'post',
    params: data
  })
}
// get衣物图片删除filePath,ossFolderName
export function deleteFile(data) {
  return axios({
    url: `/api/oms/orderItem/deleteFile`,
    method: 'get',
    params: data
  })
}
// 根据ID查询衣物
export function selectById(id) {
  return axios({
    url: `/api/oms/orderItem/selectById?id=${id}`,
    method: 'get'
  })
}
// 通过订单号修改衣物已分检(传订单号、用户ID、用户昵称)
export function updateSortOrder(nickname, orderSn, userId) {
  return axios({
    url: `/api/oms/order/sortByOrderSn?nickname=${nickname}&orderSn=${orderSn}&userId=${userId}`,
    method: 'get'
  })
}
// 通过水洗码/附件水洗码获取衣物washingCode(不改衣物状态)
export function orderItemByWashingCode(washingCode) {
  return axios({
    url: `/api/oms/orderItem/orderItemByWashingCode?washingCode=${washingCode}`,
    method: 'get'
  })
}
// 通过水洗码/附件水洗码获取衣物washingCode(总检改状态版)
export function orderItemUpdateWashingCode(washingCode) {
  return axios({
    url: `/api/oms/orderItem/orderItemUpdateByWashingCode?washingCode=${washingCode}`,
    method: 'get'
  })
}
// 获取水洗码factoryId
export function getWashCode(factoryId) {
  return axios({
    url: `/api/oms/orderItem/selectWashingCode?factoryId=${factoryId}`,
    method: 'get'
    // params: data
  })
}

// 资源列表(分页)
export function getClothingLabel(data) {
  return axios({
    url: `/api/pms/clothingLabel/listPage`,
    method: 'get',
    params: data
  })
}
// 资源查询列表(不分页)
export function getClothingLabelAll(data) {
  return axios({
    url: `/api/pms/clothingLabel/list`,
    method: 'get',
    params: data
  })
}
// 新增资源列表
export function insertClothingLabel(data) {
  return axios({
    url: `/api/pms/clothingLabel/insert`,
    method: 'post',
    data
  })
}
// 修改资源列表
export function updateClothingLabel(data) {
  return axios({
    url: `/api/pms/clothingLabel/update`,
    method: 'post',
    data
  })
}
// 删除资源列表
export function deleteClothingLabel(id) {
  return axios({
    url: `/api/pms/clothingLabel/delete?id=${id}`,
    method: 'get'
  })
}
// 资源——get上传图片接口file
export function labelUploadFile(data) {
  return axios({
    url: `/api/pms/clothingLabel/uploadFile`,
    method: 'get',
    params: data
  })
}
// 资源——post上传图片接口file
export function labelUploadFiles(data) {
  return axios({
    url: `/api/pms/clothingLabel/uploadFile`,
    method: 'post',
    data
  })
}